import * as ko from "knockout";
import * as _ from "underscore";

// Helpers
import "knockoutCustomBindings";

export interface ICloseModalAction {
    CloseModalFunction: Function,
    HideButtonCondition: KnockoutObservable<boolean>
}

export default class CloseModalAction {
    closeModalFunction: Function;
    hideButtonCondition: KnockoutObservable<boolean>;

    constructor(params: ICloseModalAction) {
        // Provided Component Properties
        this.closeModalFunction = params.CloseModalFunction || $.noop;
        this.hideButtonCondition = params.HideButtonCondition || ko.observable(false); // Note: No condition required so display button at all times
    }
}

const componentName = "close-modal-action";
ko.components.unregister(componentName);
ko.components.register(componentName, {
    viewModel: CloseModalAction,
    template: { require: 'text!/Themes/Default/Content/ts/Shared/Buttons/CloseModal/close-modal-action.html' }
});